import { applyMiddleware, compose, createStore } from 'redux';
import { History } from 'history';
import { routerMiddleware } from 'connected-react-router';
import { createLogger } from 'redux-logger';

import { epicMiddleware, rootEpic } from './rootEpic';
import rootReducer from './rootReducer';

export const createApplicationStore = (history: History) => {
  const windowIfDefined =
    typeof window === 'undefined' ? null : (window as any);

  const routerHistoryMiddleware = routerMiddleware(history);
  const composeEnhancers =
    windowIfDefined.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

  const middlewares = [routerHistoryMiddleware, epicMiddleware];

  if (process.env.REACT_APP_STORE_LOGGER === 'true') {
    middlewares.push(createLogger());
  }

  const store = createStore(
    rootReducer,
    composeEnhancers(applyMiddleware(...middlewares)),
  );
  epicMiddleware.run(rootEpic);
  return store;
};



// WEBPACK FOOTER //
// ./src/store/store.ts